module.exports = __webpack_public_path__ + "img/1sb_mini_logo_boutique.1d3d1fa.svg";